export default from './reg-item-card'
export { regItemProps } from './reg-item-props'
